import { MediationType, OperationalState } from 'src/app/core/interfaces/wellprotocol.interface';

export const malfunctionTypes = {
  Ready: {
    wellStateValue: 'N/A',
    malfunctionValue: 'N/A',
    hoaValue: 'N/A',
    className: 'gs-card--dark',
  },
  Running: {
    wellStateValue: 'Running',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Auto',
    className: 'gs-card--green',
  },
  Starting: {
    wellStateValue: 'Starting',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Auto',
    className: 'gs-card--dark',
  },
  UnableToStart: {
    wellStateValue: 'Unable To Start',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Auto',
    className: 'gs-card--orange',
  },
  StoppingViolatedUnableToStart: {
    wellStateValue: 'Stopping',
    malfunctionValue: 'Position Fault Violation',
    hoaValue: 'Auto',
    className: 'gs-card--orange',
  },
  // Unexpected data states
  StoppingMalfunctionedUnexpectedData: {
    wellStateValue: 'Stopping',
    malfunctionValue: 'I/O Malfunction',
    hoaValue: 'Auto',
    className: 'gs-card--red',
  },
  StoppingViolatedUnexpectedData: {
    wellStateValue: 'Stopping',
    malfunctionValue: 'I/O Violation',
    hoaValue: 'Auto',
    className: 'gs-card--orange',
  },
  UnableToStopViolatedUnexpectedData: {
    wellStateValue: 'Unable To Stop',
    malfunctionValue: 'I/O Violation',
    hoaValue: 'Auto',
    className: 'gs-card--orange',
  },
  UnableToStopMalfunctionedUnexpectedData: {
    wellStateValue: 'Unable To Stop',
    malfunctionValue: 'I/O Malfunction',
    hoaValue: 'Auto',
    className: 'gs-card--red',
  },
  ViolatedUnexpectedData: {
    wellStateValue: 'Stopped',
    malfunctionValue: 'I/O Violation',
    hoaValue: 'Auto',
    className: 'gs-card--orange',
  },
  MalfunctionedUnexpectedData: {
    wellStateValue: 'Stopped',
    malfunctionValue: 'I/O Malfunction',
    hoaValue: 'Auto',
    className: 'gs-card--red',
  },
  // Standard load/fluid/malfunction states
  StoppingViolatedMinLoad: {
    wellStateValue: 'Stopping',
    malfunctionValue: 'Min Load Violation',
    hoaValue: 'Auto',
    className: 'gs-card--orange',
  },
  StoppingViolatedMaxLoad: {
    wellStateValue: 'Stopping',
    malfunctionValue: 'Max Load Violation',
    hoaValue: 'Auto',
    className: 'gs-card--orange',
  },
  StoppingViolatedMinFluidLoad: {
    wellStateValue: 'Stopping',
    malfunctionValue: 'Min Fluid Load Violation',
    hoaValue: 'Auto',
    className: 'gs-card--orange',
  },
  StoppingViolatedOddSFCard: {
    wellStateValue: 'Stopping',
    malfunctionValue: 'Malfunction Point Violation',
    hoaValue: 'Auto',
    className: 'gs-card--orange',
  },
  StoppingViolatedMinFillage: {
    wellStateValue: 'Stopping',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Auto',
    className: 'gs-card--dark',
  },
  StoppingViolatedMinPIP: {
    wellStateValue: 'Stopping',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Auto',
    className: 'gs-card--dark',
  },
  StoppingViolatedSecondaryMinFillage: {
    wellStateValue: 'Stopping',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Auto',
    className: 'gs-card--dark',
  },
  StoppingViolatedSecondaryMinPIP: {
    wellStateValue: 'Stopping',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Auto',
    className: 'gs-card--dark',
  },
  StoppingViolatedTimer: {
    wellStateValue: 'Stopping',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Auto',
    className: 'gs-card--dark',
  },
  StoppingMalfunctionedUnableToStart: {
    wellStateValue: 'Stopping',
    malfunctionValue: 'Position Fault',
    hoaValue: 'Auto',
    className: 'gs-card--red',
  },
  StoppingMalfunctionedMinLoad: {
    wellStateValue: 'Stopping',
    malfunctionValue: 'Min Load',
    hoaValue: 'Auto',
    className: 'gs-card--red',
  },
  StoppingMalfunctionedMaxLoad: {
    wellStateValue: 'Stopping',
    malfunctionValue: 'Max Load',
    hoaValue: 'Auto',
    className: 'gs-card--red',
  },
  StoppingMalfunctionedMinFluidLoad: {
    wellStateValue: 'Stopping',
    malfunctionValue: 'Min Fluid Load',
    hoaValue: 'Auto',
    className: 'gs-card--red',
  },
  StoppingMalfunctionedOddSFCard: {
    wellStateValue: 'Stopping',
    malfunctionValue: 'Malfunction Point',
    hoaValue: 'Auto',
    className: 'gs-card--red',
  },
  StoppingHolded: {
    wellStateValue: 'Operator Stopping',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Auto',
    className: 'gs-card--dark',
  },
  UnableToStopViolatedUnableToStart: {
    wellStateValue: 'Unable To Stop',
    malfunctionValue: 'Position Fault Violation',
    hoaValue: 'Auto',
    className: 'gs-card--orange',
  },
  UnableToStopViolatedMinLoad: {
    wellStateValue: 'Unable To Stop',
    malfunctionValue: 'Min Load Violation',
    hoaValue: 'Auto',
    className: 'gs-card--orange',
  },
  UnableToStopViolatedMaxLoad: {
    wellStateValue: 'Unable To Stop',
    malfunctionValue: 'Max Load Violation',
    hoaValue: 'Auto',
    className: 'gs-card--orange',
  },
  UnableToStopViolatedMinFluidLoad: {
    wellStateValue: 'Unable To Stop',
    malfunctionValue: 'Min Fluid Load Violation',
    hoaValue: 'Auto',
    className: 'gs-card--orange',
  },
  UnableToStopViolatedOddSFCard: {
    wellStateValue: 'Unable To Stop',
    malfunctionValue: 'Malfunction Point Violation',
    hoaValue: 'Auto',
    className: 'gs-card--orange',
  },
  UnableToStopViolatedMinFillage: {
    wellStateValue: 'Unable To Stop',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Auto',
    className: 'gs-card--orange',
  },
  UnableToStopViolatedMinPIP: {
    wellStateValue: 'Unable To Stop',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Auto',
    className: 'gs-card--orange',
  },
  UnableToStopViolatedSecondaryMinFillage: {
    wellStateValue: 'Unable To Stop',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Auto',
    className: 'gs-card--orange',
  },
  UnableToStopViolatedSecondaryMinPIP: {
    wellStateValue: 'Unable To Stop',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Auto',
    className: 'gs-card--orange',
  },
  UnableToStopViolatedTimer: {
    wellStateValue: 'Unable To Stop',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Auto',
    className: 'gs-card--orange',
  },
  UnableToStopMalfunctionedUnableToStart: {
    wellStateValue: 'Unable To Stop',
    malfunctionValue: 'Position Fault',
    hoaValue: 'Auto',
    className: 'gs-card--red',
  },
  UnableToStopMalfunctionedMinLoad: {
    wellStateValue: 'Unable To Stop',
    malfunctionValue: 'Min Load',
    hoaValue: 'Auto',
    className: 'gs-card--red',
  },
  UnableToStopMalfunctionedMaxLoad: {
    wellStateValue: 'Unable To Stop',
    malfunctionValue: 'Max Load',
    hoaValue: 'Auto',
    className: 'gs-card--red',
  },
  UnableToStopMalfunctionedMinFluidLoad: {
    wellStateValue: 'Unable To Stop',
    malfunctionValue: 'Min Fluid Load',
    hoaValue: 'Auto',
    className: 'gs-card--red',
  },
  UnableToStopMalfunctionedOddSFCard: {
    wellStateValue: 'Unable To Stop',
    malfunctionValue: 'Malfunction Point',
    hoaValue: 'Auto',
    className: 'gs-card--red',
  },
  UnableToStopHolded: {
    wellStateValue: 'Unable To Stop',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Auto',
    className: 'gs-card--orange',
  },
  Holded: {
    wellStateValue: 'Operator Stopped',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Auto',
    className: 'gs-card--dark',
  },
  ViolatedUnableToStart: {
    wellStateValue: 'Stopped',
    malfunctionValue: 'Position Fault Violation',
    hoaValue: 'Auto',
    violationTypePath: 'unableToStart',
    className: 'gs-card--orange',
  },
  ViolatedMinLoad: {
    wellStateValue: 'Stopped',
    malfunctionValue: 'Min Load Violation',
    hoaValue: 'Auto',
    violationTypePath: 'minLoad',
    className: 'gs-card--orange',
  },
  ViolatedMaxLoad: {
    wellStateValue: 'Stopped',
    malfunctionValue: 'Max Load Violation',
    hoaValue: 'Auto',
    violationTypePath: 'maxLoad',
    className: 'gs-card--orange',
  },
  ViolatedMinFluidLoad: {
    wellStateValue: 'Stopped',
    malfunctionValue: 'Min Fluid Load Violation',
    hoaValue: 'Auto',
    violationTypePath: 'minFluidLoad',
    className: 'gs-card--orange',
  },
  ViolatedOddSFCard: {
    wellStateValue: 'Stopped',
    malfunctionValue: 'Malfunction Point Violation',
    hoaValue: 'Auto',
    violationTypePath: 'oddSFCard',
    className: 'gs-card--orange',
  },
  ViolatedMinFillage: {
    wellStateValue: 'Stopped',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Auto',
    violationTypePath: 'minFillage',
    className: 'gs-card--dark',
  },
  ViolatedMinPIP: {
    wellStateValue: 'Stopped',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Auto',
    violationTypePath: 'minPIP',
    className: 'gs-card--dark',
  },
  ViolatedSecondaryMinFillage: {
    wellStateValue: 'Stopped',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Auto',
    violationTypePath: 'secondaryMinFillage',
    className: 'gs-card--dark',
  },
  ViolatedSecondaryMinPIP: {
    wellStateValue: 'Stopped',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Auto',
    violationTypePath: 'secondaryMinPIP',
    className: 'gs-card--dark',
  },
  ViolatedTimer: {
    wellStateValue: 'Stopped',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Auto',
    violationTypePath: 'timer',
    className: 'gs-card--dark',
  },
  MalfunctionedUnableToStart: {
    wellStateValue: 'Stopped',
    malfunctionValue: 'Position Fault',
    hoaValue: 'Auto',
    className: 'gs-card--red',
  },
  MalfunctionedMinLoad: {
    wellStateValue: 'Stopped',
    malfunctionValue: 'Min Load',
    hoaValue: 'Auto',
    className: 'gs-card--red',
  },
  MalfunctionedMaxLoad: {
    wellStateValue: 'Stopped',
    malfunctionValue: 'Max Load',
    hoaValue: 'Auto',
    className: 'gs-card--red',
  },
  MalfunctionedMinFluidLoad: {
    wellStateValue: 'Stopped',
    malfunctionValue: 'Min Fluid',
    hoaValue: 'Auto',
    className: 'gs-card--red',
  },
  MalfunctionedOddSFCard: {
    wellStateValue: 'Stopped',
    malfunctionValue: 'Malfunction Point',
    hoaValue: 'Auto',
    className: 'gs-card--red',
  },
  MonitoringHoaHandMotorOn: {
    wellStateValue: 'Running',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Hand',
    className: 'gs-card--green',
  },
  MonitoringHoaHandMotorOff: {
    wellStateValue: 'Stopped',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Hand',
    className: 'gs-card--dark',
  },
  MonitoringHoaOffMotorOn: {
    wellStateValue: 'Running',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Off',
    className: 'gs-card--green',
  },
  MonitoringHoaOffMotorOff: {
    wellStateValue: 'Stopped',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Off',
    className: 'gs-card--dark',
  },
  MonitoringHoaInvalidMotorOn: {
    wellStateValue: 'Running',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Invalid',
    className: 'gs-card--green',
  },
  MonitoringHoaInvalidMotorOff: {
    wellStateValue: 'Stopped',
    malfunctionValue: 'No Malfunction',
    hoaValue: 'Invalid',
    className: 'gs-card--dark',
  },
};

/** Maps an operational state to its malfunctionTypes entry, falling back to 'Ready' for unknown states. */
export function malfunctionTypeFor(
  state?: OperationalState,
): (typeof malfunctionTypes)[keyof typeof malfunctionTypes] {
  const stateKey = OperationalState[
    state ?? OperationalState.Ready
  ] as keyof typeof malfunctionTypes;
  return malfunctionTypes[stateKey in malfunctionTypes ? stateKey : 'Ready'];
}

/** True when the given operational state represents an active malfunction (excludes 'N/A' and 'No Malfunction'). */
export function hasActiveMalfunction(state?: OperationalState): boolean {
  const value = malfunctionTypeFor(state).malfunctionValue;
  return value !== 'N/A' && value !== 'No Malfunction';
}

/** Icon class for a well's operational status when it has no active malfunction. 'Running' and
 *  any other/unmapped status return null, signaling the caller to fall back to a connection-status icon. */
export function operationalStatusIcon(state?: OperationalState): string | null {
  switch (malfunctionTypeFor(state).wellStateValue) {
    case 'Starting':
    case 'Operator Starting':
    case 'Operator Stopping':
    case 'Stopping':
      return 'fa-spinner fa-spin';
    case 'Unable To Start':
    case 'Unable To Stop':
      return 'fa-triangle-exclamation';
    case 'Stopped':
    case 'Operator Stopped':
      return 'fa-circle-stop text-danger';
    default:
      return null;
  }
}

export const isMalfunctionArray = [
  OperationalState.StoppingViolatedUnableToStart,
  OperationalState.StoppingViolatedMinLoad,
  OperationalState.StoppingViolatedMaxLoad,
  OperationalState.StoppingViolatedMinFluidLoad,
  OperationalState.StoppingViolatedOddSFCard,
  OperationalState.StoppingMalfunctionedUnableToStart,
  OperationalState.StoppingMalfunctionedMinLoad,
  OperationalState.StoppingMalfunctionedMaxLoad,
  OperationalState.StoppingMalfunctionedMinFluidLoad,
  OperationalState.StoppingMalfunctionedOddSFCard,
  OperationalState.UnableToStopViolatedUnableToStart,
  OperationalState.UnableToStopViolatedMinLoad,
  OperationalState.UnableToStopViolatedMaxLoad,
  OperationalState.UnableToStopViolatedMinFluidLoad,
  OperationalState.UnableToStopViolatedOddSFCard,
  OperationalState.UnableToStopMalfunctionedUnableToStart,
  OperationalState.UnableToStopMalfunctionedMinLoad,
  OperationalState.UnableToStopMalfunctionedMaxLoad,
  OperationalState.UnableToStopMalfunctionedMinFluidLoad,
  OperationalState.UnableToStopMalfunctionedOddSFCard,
  OperationalState.ViolatedUnableToStart,
  OperationalState.ViolatedMinLoad,
  OperationalState.ViolatedMaxLoad,
  OperationalState.ViolatedMinFluidLoad,
  OperationalState.ViolatedOddSFCard,
  OperationalState.MalfunctionedUnableToStart,
  OperationalState.MalfunctionedMinLoad,
  OperationalState.MalfunctionedMaxLoad,
  OperationalState.MalfunctionedMinFluidLoad,
  OperationalState.MalfunctionedOddSFCard,
  OperationalState.StoppingMalfunctionedUnexpectedData,
  OperationalState.StoppingViolatedUnexpectedData,
  OperationalState.UnableToStopViolatedUnexpectedData,
  OperationalState.UnableToStopMalfunctionedUnexpectedData,
  OperationalState.ViolatedUnexpectedData,
  OperationalState.MalfunctionedUnexpectedData,
];

export const resetMalfunctionArray = [
  MediationType.ResetViolationUnableToStart,
  MediationType.ResetViolationMinLoad,
  MediationType.ResetViolationMaxLoad,
  MediationType.ResetViolationMinFluidLoad,
  MediationType.ResetViolationOddSFCard,
  MediationType.ResetMalfunctionUnableToStart,
  MediationType.ResetMalfunctionMinLoad,
  MediationType.ResetMalfunctionMaxLoad,
  MediationType.ResetMalfunctionMinFluidLoad,
  MediationType.ResetMalfunctionOddSFCard,
  MediationType.ResetViolationUnexpectedData,
  MediationType.ResetMalfunctionUnexpectedData,
];

export const resetViolationDisabledStates = [
  OperationalState.StoppingMalfunctionedMaxLoad,
  OperationalState.UnableToStopMalfunctionedMaxLoad,
  OperationalState.MalfunctionedMaxLoad,
  OperationalState.StoppingMalfunctionedMinLoad,
  OperationalState.UnableToStopMalfunctionedMinLoad,
  OperationalState.MalfunctionedMinLoad,
  OperationalState.StoppingMalfunctionedOddSFCard,
  OperationalState.UnableToStopMalfunctionedOddSFCard,
  OperationalState.MalfunctionedOddSFCard,
  OperationalState.MalfunctionedMinFluidLoad,
  OperationalState.StoppingMalfunctionedUnableToStart,
  OperationalState.UnableToStopMalfunctionedUnableToStart,
  OperationalState.MalfunctionedUnableToStart,
  OperationalState.StoppingMalfunctionedUnexpectedData,
  OperationalState.UnableToStopMalfunctionedUnexpectedData,
  OperationalState.MalfunctionedUnexpectedData,
  OperationalState.UnableToStopViolatedMinFluidLoad,
];

export const resetViolationArray = [
  MediationType.ResetHoldRequest,
  MediationType.RecoverViolations,
];

export const wellCyclesDescriptors = [
  {
    filter: {
      data: {
        state: {
          $eq: 2,
        },
      },
    },
    aggMask: {
      data: {
        duration: {
          sum: 1,
        },
      },
    },
  },
  {
    filter: {
      data: {
        state: {
          $eq: 1,
        },
      },
    },
    aggMask: {
      data: {
        state: {
          count: 1,
        },
      },
    },
  },
];
